import { createSelector } from 'reselect';

const isGiftcardAddToWalletEnabledSelector = createSelector(() => {
    const isGiftcardAddToWalletEnabled = !!Sephora.configurationSettings?.['payment-service']?.allowGiftCardWalletPass;

    return isGiftcardAddToWalletEnabled;
});

export { isGiftcardAddToWalletEnabledSelector };
